import { render, staticRenderFns } from "./PesquisaAvancada.vue?vue&type=template&id=40bdf168"
import script from "./PesquisaAvancada.vue?vue&type=script&lang=js"
export * from "./PesquisaAvancada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bdf168')) {
      api.createRecord('40bdf168', component.options)
    } else {
      api.reload('40bdf168', component.options)
    }
    module.hot.accept("./PesquisaAvancada.vue?vue&type=template&id=40bdf168", function () {
      api.rerender('40bdf168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PesquisaAvancada.vue"
export default component.exports